<template>
  <div class="container">
    <div class="inner-container">
      <h2 class="title">丰富的地图服务</h2>
      <div style="display: flex; justify-content: center; margin-top: 12px">
        <div v-for="item in list"
             :key="item.title"
             class="title-item"
             @mouseover="onHover(item)"
             :class="{ active: item.title === active.title }">
          <div>
            <span style="line-height: 25px; margin-top: 12px">
              {{ item.title }}
            </span>
            <div class="underline"></div>
          </div>
        </div>
      </div>
      <div class="picture-container">
        <el-image class="picture"
                  :src="active.src"
                  fit="fill"> </el-image>
        <div :class="active.class">
          <h4 class="content-title">{{ active.title }}</h4>
          <el-image class="content-image"
                    :src="active.icon"
                    fit="fill"></el-image>
          <ul class="content-list">
            <li v-for="(item, index) in active.content"
                :key="index">
              {{ item }}
            </li>
          </ul>
          <router-link :to="active.pathLink">
            <button class="btn"
                    style="position: absolute; bottom: 30px; right: 30px">
              <span>查看详情</span>
            </button>
          </router-link>
        </div>
      </div>
      <h2 class="title"
          style="margin-top: 60px">安全稳定，保障您的业务发展</h2>
      <div class="safe-container">
        <div class="safe-item">
          <el-image class="safe-item-image"
                    :src="safeImage[0]"
                    fit="fill"></el-image>
          <h3 class="safe-item-title">稳定的服务可用性</h3>
          <div class="safe-item-content">
            超高的服务可用性 <br />
            持续稳定支持您的业务发展
          </div>
        </div>
        <div class="safe-item">
          <el-image class="safe-item-image"
                    :src="safeImage[1]"
                    fit="fill"></el-image>
          <h3 class="safe-item-title">快速的服务响应</h3>
          <div class="safe-item-content">
            快速处理到达至美团的服务请求 <br />
            为您提供高效服务
          </div>
        </div>
        <div class="safe-item">
          <el-image class="safe-item-image"
                    :src="safeImage[2]"
                    fit="fill"></el-image>
          <h3 class="safe-item-title">全方位的技术支持</h3>
          <div class="safe-item-content">
            提供全方位的技术支持<br />为服务提供保障
          </div>
        </div>
      </div>
      <h2 class="title"
          style="margin-top: 60px">开发文档</h2>
      <div class="document-container">
        <h3 style="
            font-size: 18px;
            font-family: MEITUANTYPE-BOLD;
            margin-top: 30px;
            color: rgba(0, 0, 0, 0.84);
            font-weight: 700;
            line-height: 25px;
          ">
          Web API
        </h3>
        <div class="document-item-container">
          <router-link v-for="item in list"
                       :key="item.pathLink"
                       :to="item.pathLink">
            <div class="item-list">
              <span>
                {{item.title}}
              </span>
              <el-image :src="srcWebIcon"></el-image>
            </div>
          </router-link>
        </div>
        <el-image class="document-picture"
                  :src="docImage"
                  fit="fill">
        </el-image>
        <!-- <button class="black-btn" style="position: absolute; bottom: 42px; left: 42px">查看详情</button> -->
      </div>
    </div>
  </div>
</template>
<script>
import BottomFooter from './BottomFooter.vue';
export default {
  components: { BottomFooter },
  data() {
    return {
      list: [
        {
          title: '搜索',
          content: ['关键字搜索', '多边形搜索', '周边搜索'],
          icon: require('@/assets/img/home/icon-search.svg'),
          src: require('@/assets/img/home/base-search.png'),
          class: 'yellow-content',
          pathLink: '/service/search'
        },
        {
          title: '路线规划',
          content: [
            '驾车路线规划',
            '步行路线规划',
            '骑行路线规划',
            '电动车路线规划'
          ],
          icon: require('@/assets/img/home/icon-pathplan.svg'),
          src: require('@/assets/img/home/base-pathplan.png'),
          class: 'blue-content',
          pathLink: '/service/routing'
        },
        {
          title: '地理编码',
          content: ['海量地理数据', '精准坐标解析', '支持地理结构化'],
          icon: require('@/assets/img/home/icon-geocoding.svg'),
          src: require('@/assets/img/home/base-geocoding.png'),
          class: 'green-content',
          pathLink: '/service/geo'
        },
        {
          title: '位置描述',
          content: ['海量地理数据', '准确信息描述'],
          icon: require('@/assets/img/home/icon-location.svg'),
          src: require('@/assets/img/home/base-location.png'),
          class: 'green-content',
          pathLink: '/service/regeo'
        },
        {
          title: '行政区域查询',
          content: ['海量地理数据', '丰富行政区层级'],
          icon: require('@/assets/img/home/icon-regionsearch.svg'),
          src: require('@/assets/img/home/base-regionsearch.png'),
          class: 'yellow-content',
          pathLink: '/service/division'
        },
        {
          title: '地图匹配',
          content: ['全面路网信息', '精准道路匹配'],
          icon: require('@/assets/img/home/icon-mapmatch.svg'),
          src: require('@/assets/img/home/base-mapmatch.png'),
          class: 'blue-content',
          pathLink: '/service/mapmatch'
        }
      ],
      active: {
        title: '',
        content: [],
        icon: require('@/assets/img/home/icon-search.svg'),
        src: require('@/assets/img/home/base-search.png'),
        class: '',
        pathLink: ''
      },
      safeImage: [
        require('@/assets/img/home/image-stable.png'),
        require('@/assets/img/home/image-quick.png'),
        require('@/assets/img/home/image-support.png')
      ],
      docImage: require('@/assets/img/home/development-document.png'),
      bgImageDocu: require('@/assets/img/home/bg-image-document.png'),
      srcWebIcon: require('@/assets/img/home/icon-web-arrow.svg')
    };
  },
  methods: {
    onHover(item) {
      setTimeout(() => {
        this.active = item;
      }, 400);
    }
  },
  mounted() {
    this.active = this.list[0];
  }
};
</script>
<style lang="less" scoped>
// 定义字体大小变量
@font-size-small: 14px;
@font-size-medium: 16px;
@font-size-large: 18px;

.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 60px 0;
  background-color: #f5f5f7;
  // .bg-image-container {
  //   position: absolute;
  //   width: 100%;
  //   // height: 380px;
  //   .bg-docu-picture {
  //     height: 380px;
  //     width: 1200px;
  //   }
  // }
  background-image: url(../../assets/img/home/bg-image-document.png);
  background-position: center bottom;
  background-repeat: no-repeat;
  background-size: 1440px 380px;

  .inner-container {
    width: 1200px;
    .title {
      font-size: 36px;
      color: rgba(0, 0, 0, 0.84);
      font-weight: 600;
      line-height: 50px;
    }
    .title-item {
      width: 140px;
      height: 58px;
      cursor: pointer;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: @font-size-medium;
      .underline {
        margin-top: 6px;
        width: 100%;
        height: 4px;
        background-color: transparent;
        border-radius: 100px 100px 0 0;
      }
    }
    .active span {
      color: #000;
      font-weight: 600;
    }
    .active .underline {
      background: rgba(255, 209, 0, 1);
    }

    .picture-container {
      position: relative;
      height: 460px;
      margin-top: 12px;
      .picture {
        position: absolute;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
        // opacity: 0;
        // transition: opacity 0.6s ease-in-out;
      }
      .yellow-content {
        position: absolute;
        width: 270px;
        height: 436px;
        top: 12px;
        right: 12px;
        bottom: 12px;
        background-image: linear-gradient(-45deg, #ffe75f 0%, #ffd100 100%);
        border-radius: 26px;
        padding: 30px 0 0 30px;
        .content-title {
          color: #000000;
          font-size: @font-size-large;
          font-weight: 600;
          line-height: 25px;
        }
        .content-image {
          width: 64px;
          height: 64px;
          margin-top: 50px;
        }
        .content-list {
          list-style: none;
          margin-top: 18px;
          li {
            font-family: PingFangSC-Medium;
            font-size: @font-size-small;
            color: #000000;
            font-weight: 500;
            line-height: 20px;
            margin-bottom: 6px;
          }
        }
        .btn {
          background: #1a1a1a;
          border-radius: 100px;
          color: #fff;
          font-size: 18px;
          font-weight: 600;
          line-height: 24px;
          padding: 8px 32px;
          border-radius: 20px;
          border: none;
        }
        .btn:hover {
          background-color: rgba(26, 26, 26, 0.72);
        }
      }
      .blue-content {
        position: absolute;
        width: 270px;
        height: 436px;
        top: 12px;
        right: 12px;
        bottom: 12px;
        background-image: linear-gradient(
          -45deg,
          rgba(82, 196, 255, 1) 0%,
          rgba(0, 153, 255, 1) 100%
        );
        border-radius: 26px;
        padding: 30px 0 0 30px;
        .content-title {
          color: #ffffff;
          font-size: @font-size-large;
          font-weight: 600;
          line-height: 25px;
        }
        .content-image {
          width: 64px;
          height: 64px;
          margin-top: 50px;
        }
        .content-list {
          list-style: none;
          margin-top: 18px;
          li {
            font-family: PingFangSC-Medium;
            font-size: @font-size-small;
            color: #ffffff;
            font-weight: 500;
            line-height: 20px;
            margin-bottom: 6px;
          }
        }
        .btn {
          background: #fff;
          border-radius: 51px;
          color: rgba(0, 131, 228, 1);
          font-size: 18px;
          font-weight: 600;
          line-height: 25px;
          padding: 8px 32px;
          border: none;
        }
        .btn:hover {
          background-color: rgba(255, 255, 255, 0.72);
        }
      }
      .green-content {
        position: absolute;
        width: 270px;
        height: 436px;
        top: 12px;
        right: 12px;
        bottom: 12px;
        background-image: linear-gradient(-45deg, #48dd89 0%, #00b85c 100%);
        border-radius: 26px;
        border-radius: 26px;
        padding: 30px 0 0 30px;
        .content-title {
          color: #ffffff;
          font-size: @font-size-large;
          font-weight: 600;
          line-height: 25px;
        }
        .content-image {
          width: 64px;
          height: 64px;
          margin-top: 50px;
        }
        .content-list {
          list-style: none;
          margin-top: 18px;
          li {
            font-family: PingFangSC-Medium;
            font-size: @font-size-small;
            color: #ffffff;
            font-weight: 500;
            line-height: 20px;
            margin-bottom: 6px;
          }
        }
        .btn {
          background: #fff;
          border-radius: 51px;
          color: rgba(1, 166, 92, 1);
          font-size: 18px;
          font-weight: 600;
          line-height: 25px;
          padding: 8px 32px;
          border: none;
        }
        .btn:hover {
          background-color: rgba(255, 255, 255, 0.72);
        }
      }
    }
    .picture-container:hover {
      .yellow-content {
        background-image: linear-gradient(
          -45deg,
          rgba(253, 235, 127, 1) 0%,
          rgba(255, 217, 46, 1) 100%
        );
      }
      .blue-content {
        background-image: linear-gradient(
          -45deg,
          rgba(111, 205, 255, 1) 0%,
          rgba(47, 172, 255, 1) 100%
        );
      }
      .green-content {
        background-image: linear-gradient(
          -45deg,
          rgba(105, 226, 158, 1) 0%,
          rgba(47, 197, 122, 1) 100%
        );
      }
    }
    .safe-container {
      margin-top: 24px;
      background: #fff;
      height: 320px;
      border-radius: 26px;
      padding: 18px;
      display: flex;
      .safe-item {
        flex: 1;
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;
        .safe-item-image {
          margin-top: 24px;
          width: 90px;
          height: 90px;
        }
        .safe-item-title {
          font-family: PingFangSC-Medium;
          margin-top: 4px;
          font-size: 18px;
          color: rgba(0, 0, 0, 0.84);
          font-weight: 500;
          line-height: 25px;
        }
        .safe-item-content {
          text-align: left;
          margin-top: 24px;
          font-size: 14px;
          color: rgba(0, 0, 0, 0.5);
          line-height: 24px;
          font-weight: 400;
        }
      }
    }
    .document-container {
      margin-top: 24px;
      position: relative;
      height: 320px;
      background: #fff;
      border-radius: 26px;
      padding: 12px 12px 12px 42px;
      .document-item-container {
        margin-top: 18px;
        .item-list {
          height: 20px;
          display: flex;
          align-items: center;
          margin-bottom: 12px;
          span {
            font-size: @font-size-small;
            color: rgba(0, 0, 0, 0.6);
            font-weight: 400;
            line-height: 20px;
          }
          span:hover {
            color: rgba(164, 110, 0, 1);
          }
          .el-image {
            display: inline-block;
            margin-left: 6px;
            height: 20px;
          }
        }
      }
      .document-picture {
        position: absolute;
        right: 12px;
        top: 12px;
        bottom: 12px;
        width: 900px;
      }
    }
  }
}
</style>
